export default {
      id: "war-usage",
      viewBox: "0 0 26 32",
      url: __webpack_public_path__ + "sprite.svg#war",
      toString: function () {
        return this.url;
      }
    }